function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M11 13.37V5a1 1 0 112 0v8.467l2.631-2.924a1 1 0 011.487 1.338l-5.012 5.568a.085.085 0 01-.126 0L6.97 11.881a1 1 0 111.487-1.338L11 13.371zM20 15a1 1 0 112 0v6a1 1 0 01-1 1H3a1 1 0 01-1-1v-6a1 1 0 112 0v5h16v-5z"
});

var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), _ref);
};

export default SvgDownload;